export enum PlaylistExperience {
  Arena = 2,
  Social = 3,
  Featured = 5,
}
